<template>
  <div class="multiselect"
       @click.stop="multiple = true">
    <a href="javascript: void(0);" class="multiselect-btn major-btn-norm f-cb" @click.stop="switchShow">
      <template v-if="type === 'selectColor'">
        <img src="../../assets/images/preview/colorFilter.png" alt="">
        <span>颜色过滤</span>
      </template>
      <template v-else>+多选</template>
    </a>
    <div v-show="multiple" class="multiselect-box major-box j-drop">
      <em></em>
      <label class="checkAllBqcatalog f-cb">
        <w-checkbox v-model="selectAll" @change="selectChange()" style="margin-right: 0;">全选</w-checkbox>
        <!--<input class="float_left" type="checkbox" v-model="selectAll" @change="selectChange()">-->
        <!--<span class="float_left" >全选</span>-->
      </label>
      <div class="multiselect-content">
        <w-scrollbar wrap-style="overflow-x: hidden;" style="width: 100%;height: 98%;overflow-x: hidden;">
          <a v-for="(item, j) in list" href="javascript: void(0);"
             @click="selectChange(simple ? item : item[value])"
             :class="['multi-item f-cb', (nowSelected.indexOf((simple ? item : item[value])) > -1) ? 'selected' : '']"
             :key="'all_' + j">
            <template v-if="type === 'selectColor'">
              <input type="checkbox" :checked="nowSelected.indexOf(item.value) > -1">
              <span :style="{'background-color': item.value}" class="bg"></span>
              <span class="txt">{{item.label}}</span>
            </template>
            <template v-else>
              <i class="w-icon-tijiao"></i>
              {{simple ? item : item[label]}}
            </template>
          </a>
        </w-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
import {mapState, mapMutations} from 'vuex'
import {UUID} from '@/assets/utils'
export default {
  name: 'MultipleSelect',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    selected: { // 已选择项
      type: Array,
      default: () => []
    },
    value: { // 复杂 数组需要指明 key 和 label
      type: String,
      default: 'value'
    },
    label: {
      type: String,
      default: 'name'
    },
    name: {
      type: String,
      default: new Date().getTime() + ''
    },
    refreshIndex: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: '' // selectColor: 选择颜色（样式的区别）
    },
    simple: { // 简单数组 ['选项1', '选项2']
      type: Boolean,
      default: false
    },
    parentRegion: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      multiple: false, // 显示多选下拉框
      selectAll: false,
      nowSelectedObj: {},
      nowSelected: [], // 当前已选择项
      uuidVal: '',
      clickHandle: null
    }
  },
  computed: {
    ...mapState({
      selectUUID: state => state.config.selectUUID
    })
  },
  beforeDestroy () {
    this.initEvent()
  },
  mounted () {
    const obj = UUID()
    this.uuidVal = obj.uuidVal || new Date().getTime()
    this.initEvent(true)
    this.refreshSelect()
  },
  methods: {
    ...mapMutations({
      setNowSelectUUID: 'config/SET_NOW_SELECT_UUID'
    }),
    // 1. 初始化、刷新视图
    refreshSelect () {
      this.multiple = false
      let nowSelected = []
      this.nowSelectedObj = {}
      if (this.selected.length) {
        this.selected.forEach((item) => {
          nowSelected.push(item)
          this.$set(this.nowSelectedObj, item, true)
        })
      }
      this.nowSelected = nowSelected
      this.selectAll = (this.list.length && this.selected.length === this.list.length)
    },
    // 2. 切换选择时
    selectChange (item) {
      if (item) {
        if (!this.nowSelectedObj[item]) {
          this.$set(this.nowSelectedObj, item, true)
        } else {
          this.$delete(this.nowSelectedObj, item)
        }
      } else {
        this.nowSelectedObj = {}
        if (this.selectAll) {
          this.list.forEach((item) => {
            const key = this.simple ? item : item[this.value]
            this.$set(this.nowSelectedObj, key, true)
          })
        }
      }
      let nowSelected = []
      this.list.forEach((item) => {
        const key = this.simple ? item : item[this.value]
        if (this.nowSelectedObj[key]) {
          nowSelected.push(key)
        }
      })
      if (nowSelected.length === this.list.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
      this.nowSelected = nowSelected
      this.$emit('change', nowSelected, this.name)
    },
    // 3. 多选按钮点击时
    switchShow () {
      this.multiple = !this.multiple
      this.setNowSelectUUID(this.uuidVal)
    },
    // 4. 注册页面点击事件
    initEvent (init) {
      off(document, 'click', this.clickHandle = () => {})
      if (this.clickHandle) {
        this.clickHandle = null
      }
      if (!init) return
      on(document, 'click', this.clickHandle = () => {
        this.multiple = false
      })
    }
  },
  watch: {
    'refreshIndex': function () {
      this.refreshSelect()
    },
    'selectUUID': function () {
      if (this.selectUUID !== this.uuidVal) {
        this.multiple = false
      }
    }
  }
}
</script>
